<template>
  <tr>
    <td>
      <div>{{onlyDate}}</div>
      <div>{{onlyTime}}</div>
    </td>
    <td>
      <p>{{item.title}}</p>
      <span
        class="card"
        :class="fecture.flag"
        v-bind:key="fecture.index"
        v-for="fecture in fectures"
        @click="goto(fecture)"
      >{{fecture.flag}}</span>
    </td>
  </tr>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    fectures() {
      return this.item.fectures;
    },
    onlyTime() {
      return this.moment(this.item.timetable_date).format("HH:mm");
    },
    onlyDate() {
      return this.moment(this.item.timetable_date).format("YY-MM-DD");
    }
  },
  methods: {
    goto(fecture) {
      if (fecture.flag === "quiz") {
        if (fecture.subflag === "live") {
        } else {
          this.$router.push("/non/fulllist/quiz");
        }
      }
      if (fecture.flag === "poll") {
        if (fecture.subflag === "live") {
        } else {
          this.$router.push("/non/fulllist/poll");
        }
      }

      if (fecture.flag === "share") {
        this.$router.push("/slide/list/");
      }

      if (fecture.flag === "qna") {
        this.$router.push("/qna/fulllist");
      }
    }
  }
};
</script>


<style lang="scss" scoped>
span {
  margin-left: 2px;
  margin-bottom: 2px;
}

.ttable {
  position: relative;
  z-index: 2;
  border-radius: 10px;
  background: #ffffff;
  width: 90%;
  margin: 10px auto;
  padding-bottom: 30px;
  box-shadow: 5px 5px 10px 2px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.ttable .date {
  background: #f7f7f7;
  padding: 15px 0;
}

.ttable .date .select {
  position: relative;
  width: 80%;
  margin: 0 auto;
}

.ttable .date .select h3 {
  position: relative;
  height: 35px;
  line-height: 35px;
  border: 1px solid #e5e5e5;
  padding: 0 30px 0 15px;
  border-radius: 10px;
  color: #666666;
  font-size: 14px;
  text-align: left;
  margin: 0 auto;
  background: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ttable .date .select h3 img {
  position: absolute;
  right: 15px;
  top: 50%;
  margin-top: -3.5px;
  width: 13px;
}

.ttable .date .select.open h3 img {
  transform: rotate(180deg);
}

.ttable .date .select ul {
  border: 1px solid #e5e5e5;
  position: absolute;
  width: 100%;
  left: 0;
  top: 34px;
  border-radius: 10px;
  height: 200px;
  overflow-y: auto;
  display: none;
}

.ttable .date .select.open ul {
  display: block;
}

.ttable .date .select ul li {
  border-top: 1px solid #e5e5e5;
  background: #ffffff;
  padding: 0 15px;
  text-align: left;
  font-size: 14px;
  color: #666666;
}

.ttable .date .select ul li:first-child {
  border-top: none;
}

.ttable .date .select ul li a {
  display: block;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ttable .tbody table {
  width: 100%;
}

.ttable .tbody table th,
.ttable .tbody table td {
}

.ttable .tbody table th {
  text-align: center;
  color: #666666;
  font-size: 14px;
  padding: 15px 0;
  border-bottom: 1px solid #2f2f30;
  font-weight: 700;
}

.ttable .tbody table td {
  text-align: left;
  padding: 10px 0;
  border-bottom: 1px solid #f3f3f3;
}

.ttable .tbody table tr td:first-child {
  text-align: center;
  color: #666666;
  font-size: 14px;
}

.ttable .tbody table td p {
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
}

.ttable .tbody table td span.card {
  width: 47px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  background: #3a5cd9;
  display: inline-block;
  vertical-align: top;
  border-radius: 4px;
}

.ttable .tbody table td span.quiz {
  background: #30c0bd;
}

.ttable .tbody table td span.qna {
  background: #dc688f;
}

.ttable .tbody table td span.poll {
  background: #efc774;
}

.ttable .tbody table td span.share {
  background: #e0dd37;
}
</style>